import React from 'react';
import { Tabs, Tab, Theme, Box, Button, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Add } from '@material-ui/icons';
import { useHistory, useLocation } from 'react-router';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';
import {
  useEnterpriseLock,
  EnterpriseLockNotice,
  lockedTooltip,
} from '../../../global/auth/use-enterprise-lock/use-enterprise-lock';

export enum FormsTabEnum {
  FORMS = 'Forms',
}

const tabs = ['Forms'];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabRoot: {
      color: theme.color.grey.neutralBrand800,
      textTransform: 'capitalize',
      fontWeight: 800,
      fontSize: '20px',
      letterSpacing: '-0.02em',
      minWidth: 'unset',
      opacity: 0.7,
    },
    selected: {
      color: `${theme.color.grey.neutralBrand900} !important`,
      opacity: 1,
    },
    tabsFlexContainer: {
      alignContent: 'space-between',
      borderBottom: '2px solid',
      borderBottomColor: '#EFEFEF',
    },
  })
);

interface FormsMenuToolbarProps {
  isFormsTab?: boolean;
}

const FormsMenuToolbar = ({ isFormsTab = false }: FormsMenuToolbarProps) => {
  const history = useHistory();
  const location = useLocation();
  const { theme, isMobile, isMd } = useCampfireTheme();
  const isLocked = useEnterpriseLock();

  const handleCreateForm = () => {
    history.push(`${location.pathname}/form-builder`);
  };

  if (!isFormsTab) {
    return null;
  }

  if (isLocked) {
    return (
      <Box display='flex' justifyContent='flex-end' flex={1} alignItems='center'>
        <EnterpriseLockNotice tooltip={lockedTooltip('Forms')} />
      </Box>
    );
  }

  return (
    <Box display='flex' justifyContent='flex-end' flex={1} alignItems='center'>
      <Button
        variant='contained'
        color='primary'
        startIcon={<Add />}
        onClick={handleCreateForm}
        style={{
          backgroundColor: theme.color.secondary.main900,
          color: '#ffffff',
          textTransform: 'none',
          borderRadius: '4px',
          padding: !isMobile || !isMd ? '7px 12px' : '7px 7px',
          minWidth: '40px',
        }}
      >
        <Typography
          style={{
            marginLeft: '8px',
            fontWeight: 600,
            fontSize: '13px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            display: isMobile || isMd ? 'none' : 'inherit',
          }}
        >
          Create Form
        </Typography>
      </Button>
    </Box>
  );
};

export const FormsMenubar = () => {
  const classes = useStyles();
  const rootPathname = '/admin/forms';
  const location = useLocation();
  const history = useHistory();
  const { isMobile } = useCampfireTheme();

  const selectedTab = location.pathname.split('/')[3] || tabs[0];

  const handleChange = (_unused: any, newValue: FormsTabEnum) => {
    if (newValue === tabs[0]) {
      history.push(`${rootPathname}`);
    } else {
      history.push(`${rootPathname}/${newValue}`);
    }
  };

  if (isMobile) {
    return (
      <Box display='flex' alignItems='center' style={{ paddingBottom: '10px', borderBottom: '2px solid #EFEFEF' }}>
        <Typography variant='h6' style={{ fontWeight: 800, fontSize: '20px' }}>
          {selectedTab}
        </Typography>
        <FormsMenuToolbar isFormsTab={selectedTab === FormsTabEnum.FORMS} />
      </Box>
    );
  }

  return (
    <Tabs
      value={selectedTab || FormsTabEnum.FORMS}
      onChange={handleChange}
      indicatorColor='primary'
      textColor='primary'
      aria-label='forms tabs'
      classes={{
        flexContainer: classes.tabsFlexContainer,
      }}
    >
      <Tab label='Forms' classes={{ selected: classes.selected, root: classes.tabRoot }} value={FormsTabEnum.FORMS} />
      <FormsMenuToolbar isFormsTab={selectedTab === FormsTabEnum.FORMS} />
    </Tabs>
  );
};
